export default __webpack_public_path__ + "static/media/bg.3bd65274.svg";